import React, { useEffect, useState } from 'react';
import { useStore } from '../state/store';
import { Card, Banner, Chip, SectionHead } from '../components/ui';
import { TheBridge } from '../components/TheBridge';
import { api } from '../state/api';

/**
 * Diagnostics / Audit — plan versions, freshness, validators, AI machinery.
 * Kept off the founder Today path on purpose.
 */
export default function Diagnostics({ go }) {
  const { state } = useStore();
  const [planStatus, setPlanStatus] = useState(null);
  const versions = [...(state.planVersions || [])].sort((a, b) =>
    String(b.createdAt || '').localeCompare(String(a.createdAt || '')),
  );

  useEffect(() => {
    api.planStatus().then(setPlanStatus).catch(() => setPlanStatus(null));
  }, [state.planVersions]);

  return (
    <>
      <div className="page-head">
        <div className="row">
          <h2>Diagnostics / Audit</h2>
          <div className="spacer" />
          <button type="button" className="btn sm ghost" onClick={() => go('command')}>Back to Today</button>
        </div>
        <div className="sub">Inspectable autonomy — plan versions, freshness, validators, The Bridge machinery.</div>
      </div>

      <section className="section">
        <Card title="Plan freshness">
          <div className="row wrap" style={{ gap: 8 }}>
            <Chip>{planStatus?.freshness || 'unknown'}</Chip>
            <span className="dim tiny">{planStatus?.inputAsOf || ''}</span>
          </div>
          {planStatus?.freshness === 'stale' && (
            <Banner tone="amber">PLAN STALE — newer commercial state awaiting re-study</Banner>
          )}
          {(planStatus?.error || planStatus?.lastError) && (
            <Banner tone="bad">{planStatus.error || planStatus.lastError}</Banner>
          )}
        </Card>
      </section>

      <section className="section">
        <SectionHead title="Plan versions" hint="Immutable audit trail." />
        <Card flush>
          {versions.length === 0 ? (
            <div style={{ padding: 14 }} className="dim">No plan versions yet.</div>
          ) : (
            versions.slice(0, 12).map((v) => (
              <div key={v.id} className="row" style={{ padding: '10px 14px', borderBottom: '1px solid var(--line-2)' }}>
                <Chip>{v.rejected ? 'rejected' : 'ok'}</Chip>
                <span style={{ flex: 1 }} className="dim tiny">{v.id}</span>
                <span className="dim tiny">{String(v.createdAt || '').slice(0, 19)}</span>
              </div>
            ))
          )}
        </Card>
      </section>

      <section className="section">
        <SectionHead title="The Bridge (full)" hint="Recommendations, Ask, specialists, plan controls." />
        <TheBridge />
      </section>
    </>
  );
}
